module.exports = __webpack_public_path__ + "static/media/appStore.29fed48a.png";